import { useSelector } from 'react-redux'
import { defineMessages, useIntl } from 'react-intl'
import { match as reactRouterMatch } from 'react-router'
import Loading from '../../Components/shared/Loading/LoadingApp'
import OverlayMask from '../../Components/shared/Routing/OverlayMask'
import { AppHeader } from './AppHeader'
import { AuthErrorModal } from '../../features/AuthErrorModal'
import { selectBuyerErrorModal } from '../../store/selectors/buyerInfo'
import { selectHomeIsErrored } from '../../store/selectors/home'
import { selectCustomerProfileState } from '../../store/selectors/customerProfile'
import { SkipNavLink, Text } from '@homebotapp/hb-react-component-catalog'
import { AuthErrorModalErrorTypes } from '../../types/error'
import useViewport from '../../hooks/useViewport'
import { BottomNav } from '../../Components/shared/BottomNav'
import { GuestAuthModal } from '../../features/GuestAuthModal/GuestAuthModal'
import styles from './AppLayout.module.scss'

const MSG = defineMessages({
  skiptocontent: {
    id: 'General.a11y.skiptocontent',
    defaultMessage: 'Skip to Content'
  }
})

export type AppLayoutProps = {
  children: React.ReactNode
  enableAgentDropdown: boolean
  loading: boolean
  match: reactRouterMatch
}

export const AppLayout = ({ children, enableAgentDropdown, loading, match }: AppLayoutProps) => {
  const intl = useIntl()
  const { isMedium } = useViewport()

  const hasHomeownerError = useSelector(selectHomeIsErrored)
  const hasBuyerError = useSelector(selectBuyerErrorModal)
  const customerState = useSelector(selectCustomerProfileState)

  const customerIsInactive = customerState && customerState !== 'active'

  const showAuthErrorModal = hasHomeownerError || hasBuyerError || customerIsInactive

  const errorType =
    (hasHomeownerError && AuthErrorModalErrorTypes.HOMEOWNER_ERROR) ||
    (hasBuyerError && AuthErrorModalErrorTypes.BUYER_ERROR) ||
    (customerIsInactive && AuthErrorModalErrorTypes.CUSTOMER_ERROR)

  return (
    <>
      {loading && <Loading />}
      <OverlayMask loading={loading} isExact={match.isExact}>
        <SkipNavLink>
          <Text>{intl.formatMessage(MSG.skiptocontent)}</Text>
        </SkipNavLink>
        <AppHeader enableAgentDropdown={enableAgentDropdown} />
        {/* applies a uniform margin to account for fixed-position mobile header */}
        <div data-qa='mobilecontents' className={styles.mobilecontents}>
          {!showAuthErrorModal && children}
        </div>
        {isMedium && <BottomNav />}
      </OverlayMask>
      {showAuthErrorModal && !loading && (
        <AuthErrorModal showAuthErrorModal={showAuthErrorModal} errorType={errorType} />
      )}

      <GuestAuthModal />
    </>
  )
}
